import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { isIE } from '../../utils/helper';

export const Container = styled.div`
  background-color: #f6f9fc;
  display: flex;
  flex-direction: column;
  text-align: center;
  ${() => isIE() ? `height: 100vh;` :`min-height: 100vh;`}
`;

export const LogosContainer = styled.div`
  align-items: center;
  background-color: white
  display: flex;
  justify-content: center;
  padding: 1rem 2rem;
  z-index: 1;

  ${breakpoint('tablet')`
    justify-content: flex-start;
  `}
`;

export const AppTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 0.5rem;
  z-index: 1;

  ${breakpoint('tablet')`
    font-size: 3rem;
    margin-bottom: 1rem;
  `}
`;

export const Anchor = styled.a`
  color: #fff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
  &.left-footer {
    margin-right: 0.5rem;
  }
  &.right-footer {
    margin-left: 0.5rem;
  }
`;



// WEBPACK FOOTER //
// ./src/containers/App/styledComponents.js